<template>
  <div class="body">
    <header
      class="header"
      :class="{ transparent: isTransparent, scrolled: isScrolled }"
    >
      <nav class="navbar">
        <!-- 导航栏内容，如logo、菜单链接等 -->
        <div class="nav-header">
          <img
            src="/static/img/ar.jpg"
            style="
              height: 35px;
              margin-top: 15px;
              margin-left: 15px;
              border-radius: 35px;
            "
            alt="logo"
          />
        </div>
        <ul class="nav-menu">
          <li>
            <a href="#" style="font-size: 22px; font-weight: bold">首页</a>
          </li>
          <li>
            <a href="https://editor.pointslines.com" style="font-size: 22px; font-weight: bold">产品</a>
          </li>
        </ul>
      </nav>
    </header>
    <div class="image-container">
      <div class="text-overlay">
        点线空间
        <div class="line"></div>
        <el-button type="text">快速开始</el-button>
      </div>
    </div>
    <div class="introduce">
      <div class="introduce_text">
        <span class="introduce_title">无需编程，轻松打造专业 AR 效果</span>
      </div>
      <div class="editor_box">
        <div class="introduce_content_visableEditor">
          <span class="editor_title">可视化编辑器，创作零门槛</span>
          <span class="editor_content"
            >支持 3D 模型、粒子特效、视频、透明视频、图片</span
          >
          <span class="editor_content">项目成型简单高效</span>
        </div>
        <div class="introduce_content_image">
          <img
            src="/static/img/homePageTest2.jpg"
            alt="img"
            style="height: 400px; width: 100%; border-radius: 5px"
          />
        </div>
      </div>
      <div class="introduce_text">
        <span class="introduce_title">定制化建模，创造专属AR世界</span>
      </div>

      <div class="model_box">
        <div class="introduce_content_image">
          <img
            src="/static/img/homePageTest2.jpg"
            alt="img"
            style="height: 400px; width: 100%; border-radius: 5px"
          />
        </div>
        <div class="model_content">
          <span class="model_title">上传视频</span>
          <div class="line"></div>
          <span class="editor_content">项目成型简单高效</span>
        </div>
      </div>
      <div style="margin: 8vh"></div>
      <div class="model_box">
        <div class="model_content">
          <span class="model_title">一键建模</span>
          <div class="line" ref="lines"></div>
          <span class="editor_content">项目成型简单高效</span>
        </div>

        <div class="introduce_content_image">
          <img
            src="/static/img/homePageTest2.jpg"
            alt="img"
            style="height: 400px; width: 100%; border-radius: 5px"
          />
        </div>
      </div>

      <div class="introduce_text">
        <span class="introduce_title">AR案例</span>
      </div>

      <el-carousel
        :interval="4000"
        type="card"
        height="500px"
        style="width: 800px"
      >
        <el-carousel-item v-for="item in 4" :key="item">
          <div class="video_center">
            <video
              :src="`/static/video/carousel_video/carousel_video${item}.mp4`"
              alt="carousel video"
              style="width: auto; height: 450px; object-fit: cover"
              autoplay
              loop
              muted
            ></video>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <footer>
      <div class="footer_content">
        <div class="footer_contact"></div>
        <div class="footer_recordFiling">
          <div class="footer_recordFiling_police">
            <img
              src="https://editor.pointslines.com/static/beian.png"
              alt="recordFiling"
              style="height: 20px; width: 20px"
            />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch"
              target="_blank"
              style="color: black"
            >
              闽公网安备35052102000587号</a
            >
          </div>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="margin-left: 10px; color: black"
          >
            闽ICP备2024043162号-2</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      isTransparent: true,
      prevScrollTop: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // 创建 Intersection Observer 实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 当元素进入视口时，添加动画类
          console.log(this.$refs.lines);
          entry.target.classList.add("line-animate");
        } else {
          // 当元素离开视口时，移除动画类
          entry.target.classList.remove("line-animate");
        }
      });
    });

    // 获取所有 .line 元素并开始监听
    const lines = document.querySelectorAll(".line");
    lines.forEach((line) => observer.observe(line));
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset;
      const ninetyVH = window.innerHeight * 0.85;

      if (scrollTop > ninetyVH && scrollTop > this.prevScrollTop) {
        this.isScrolled = true;
        this.isTransparent = false;
      } else if (scrollTop < ninetyVH && scrollTop < this.prevScrollTop) {
        this.isScrolled = false;
        this.isTransparent = true;
      }
      this.prevScrollTop = scrollTop;
    },
  },
};
</script>

<style scoped>
.nav-header {
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  position: relative;
  z-index: 1;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("/static/img/homePageTest1.jpg");
  background-attachment: fixed;
}

.image-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: transparent;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 100px;
  color: white;
  opacity: 1;
  display: flex;
  flex-direction: column;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}

.header.transparent {
  background-color: transparent;
}

.header.scrolled {
  background-color: white;
}

.nav-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.nav-menu li {
  margin-right: 10px;
}

.header.transparent .nav-menu li a {
  color: white;
}

.header.scrolled .nav-menu li a {
  color: #000;
}

.nav-menu li a {
  text-decoration: none;
  padding: 5px 10px;
}

.introduce {
  height: 400vh;
  width: 100%;
  background-color: #f9fafb;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.el-button--text {
  color: #b8becc;
}
.introduce_title {
  font-size: 38px;
  font-weight: bold;
}
.introduce_text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5%;
  margin-bottom: 5%;
}
.editor_box {
  width: 80%;
  height: 60vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  padding: 50px 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.editor_box:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.introduce_content_visableEditor {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.introduce_content_image {
  display: flex;
  flex-direction: column;
  flex: 1;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.editor_title {
  font-size: 30px;
  font-weight: bold;
  margin: auto;
  margin-bottom: 15px;
}
.editor_content {
  margin: auto;
  margin-bottom: 15px;
  color: rgb(75, 85, 99);
  font-size: 18px;
}
.model_title {
  font-size: 30px;
  font-weight: bold;
  margin: auto;
}
.model_content {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.line {
  width: 1%;
  margin: 30px auto;
  border-bottom: 2px solid #b8becc;
  transition: width 1s ease;
}

.line-animate {
  width: 50%;
}

.model_box {
  width: 80%;
  height: 60vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 5px;
  overflow: hidden;
  padding: 50px 30px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: transparent;
}
footer {
  padding: 100px 0 95px;
}
.footer_content {
  display: flex;
}
.footer_contact {
  display: flex;
  flex-direction: column;
}
.footer_recordFiling {
  display: flex;
}
.footer_recordFiling_police {
  display: flex;
}
.video_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>    


// WEBPACK FOOTER //
// src/components/homePage.vue